export default {
    key: 'rental-ski',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: false,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: false,
    isRental: true,
    activityId: 'urn:ts:activity:intersport-rentals:b83e449b-7d1a-4d22-9a04-58eb4c0b6b29',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: true,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    // Body data is collected per equipment in the rental steps, not on the passenger
    hidePassengerMeasurements: true,
    isUsingPromos: false,
    isPromotionRequired: false,
    showDuration: true,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:activity:intersport-rentals:b83e449b-7d1a-4d22-9a04-58eb4c0b6b29',
    contentfulId: 'rental-ski',
    steps: [],
} satisfies ProductConfigActivity;
